import React,{useEffect, useRef, useState} from 'react'
import partyAddressServices from '../partyAddressServices';
import { Dialog, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import PartyAddressForm from './PartyAddressForm';
import { useAppData } from '../../../../../../context/AppDataContext';
import { Edit } from '@mui/icons-material';


function SelectPartyAddress({partyId, callBack,caption,address}) {
    const [partyAddressList,setPartyAddressList] = useState(null);
    const [loading,setLoadingStatus] = useState(false);
    const {getMasterLabel} = useAppData();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [showForm,setShowFormStatus] = useState(false);
    const focusButtonRef = useRef(null)

    const getPartyAddressList = () =>{
        setLoadingStatus(true);
        setDialogStatus(true);
        partyAddressServices.getByPartyId(partyId).then(res=>{
            setPartyAddressList(res.data);
            console.log(res.data.length);
            if(res.data.length === 0){
                console.log("I am here in this");
                setShowFormStatus(true);
            }
            if(res.data.length > 0 ){

                if(res.data.length == 1){
                    //console.log("here");
                    //callBack(res.data[0].id)
                }

                const timer = setTimeout(() => {
                if (focusButtonRef.current) {
                    focusButtonRef.current.focus();
                }
                }, 100); // Gives the modal animation a brief moment to settle
            }
        }).catch(error=>{
            console.log(error);
        }).finally(()=>{
            setLoadingStatus(false);
        })
    }

    const selectAddress = (partyAddress) =>{
        setDialogStatus(false);

        const cityZip = [partyAddress?.city, partyAddress?.zip].filter(Boolean).join(' - ');

        const addressString = [
            partyAddress?.contactPerson || '',
            partyAddress?.address || '',
            cityZip,
            partyAddress?.phone ? `Phone: ${partyAddress.phone}` : ''
        ].filter(Boolean).join('\n');
        

        let address = {
            addressString:addressString,
            address:partyAddress,
        }
        //console.log(address);

        callBack(address);
    }

    useEffect(()=>{
        if(!address){
            getPartyAddressList();
        }
    },[address])
    
    
    return (
        <>
            {address ? 
                <Tooltip title="Update">
                    {/*<button type="button" className="btn btn-outline-primary" onClick={updateData} ><Edit/> Address</button> */}
                    <IconButton className="delete-icon me-2" onClick={getPartyAddressList} style={{padding:"0px"}} >
                        <Edit/>
                    </IconButton>
                </Tooltip>
                :
                <button className='btn btn-primary me-2' onClick={getPartyAddressList}>{caption ? caption :"Select Party Address"}</button>
            }
            
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={()=>setDialogStatus(false)}
                fullWidth={true}
                maxWidth="md"
            >
                <DialogTitle>Select {caption}</DialogTitle>
                <DialogContent>
                    {partyAddressList && partyAddressList.length == 0 &&
                        <div className='card mb-2'>
                            <div className='card-body text-center'>No Address found</div>
                        </div>
                    }
                    {partyAddressList?.map((partyAddress,i)=>
                        <div className='card mb-2'>
                            <div className='card-body'>
                                <div className='float-end'>
                                    <PartyAddressForm partyId={partyId} data={partyAddress} callback={getPartyAddressList} />
                                </div>
                                <div>{partyAddress.contactPerson}</div>
                                <div>{partyAddress.address}</div>
                                <div>{partyAddress.city}, { getMasterLabel("indian-state",partyAddress.state) }, {partyAddress.zip}</div>
                                <div>{partyAddress.phone}, {partyAddress.email}</div>
                                {partyAddress.supplyState !== partyAddress.state && 
                                    <div className='text-info' >Supply To : { getMasterLabel("indian-state",partyAddress.supplyState) }</div> 
                                }
                            </div>
                            {callBack &&
                                <div className='card-footer text-center'>
                                    {i===0 ?
                                        <button className='btn btn-success' ref={focusButtonRef} onClick={()=>selectAddress(partyAddress)}>Select this as {caption}</button>
                                        :
                                        <button className='btn btn-success' onClick={()=>selectAddress(partyAddress)}>Select this as {caption}</button>
                                    }
                                    
                                </div>
                            }
                        </div>
                    )}
                    <div className='card'>
                        <div className='card-body text-center'>
                            <PartyAddressForm partyId={partyId} callback={getPartyAddressList} defaultOpen={showForm} />
                        </div>
                    </div>
                    
                </DialogContent>
            </Dialog>
        </>
    )
}

export default SelectPartyAddress